/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDinnerDiningIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-dinner-dining"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.67 21.8Q4.28 21.8 3.91 21.65Q3.55 21.5 3.27 21.23L2.33 20.27Q2 19.95 2.17 19.55Q2.35 19.15 2.8 19.15L21.2 19.15Q21.65 19.15 21.82 19.55Q22 19.95 21.68 20.27L20.73 21.23Q20.45 21.5 20.09 21.65Q19.73 21.8 19.32 21.8ZM2.2 18.15Q2.35 17.65 2.6 17.19Q2.85 16.73 3.2 16.32L3.2 9.2L3.15 9.2Q2.75 9.2 2.48 8.93Q2.2 8.65 2.2 8.25Q2.2 7.85 2.48 7.58Q2.75 7.3 3.15 7.3L3.2 7.3L3.2 6.65L3.15 6.65Q2.75 6.65 2.48 6.38Q2.2 6.1 2.2 5.7Q2.2 5.3 2.48 5.03Q2.75 4.75 3.15 4.75L3.2 4.75L3.2 4.1L3.15 4.1Q2.75 4.1 2.48 3.83Q2.2 3.55 2.2 3.15Q2.2 2.75 2.48 2.48Q2.75 2.2 3.15 2.2L9.43 2.2Q10.47 2.2 11.22 2.95Q11.97 3.7 11.97 4.75L11.97 4.75L20.85 4.75Q21.25 4.75 21.52 5.03Q21.8 5.3 21.8 5.7Q21.8 6.1 21.52 6.38Q21.25 6.65 20.85 6.65L11.97 6.65L11.97 6.67Q11.97 7.72 11.22 8.46Q10.47 9.2 9.43 9.2L7.7 9.2L7.7 14.75Q7.97 14.8 8.24 14.86Q8.5 14.93 8.78 15.05Q9.63 13.4 11.16 12.43Q12.7 11.45 14.53 11.45Q17.13 11.45 18.95 13.29Q20.77 15.13 20.77 17.73L20.77 18.15ZM7.7 4.75L9.32 4.75L9.32 4.1Q9.32 4.1 9.32 4.1Q9.32 4.1 9.32 4.1L7.7 4.1ZM7.7 7.3L9.32 7.3Q9.32 7.3 9.32 7.3Q9.32 7.3 9.32 7.3L9.32 6.65L7.7 6.65ZM5.1 4.75L5.8 4.75L5.8 4.1L5.1 4.1ZM5.1 7.3L5.8 7.3L5.8 6.65L5.1 6.65ZM5.1 15Q5.28 14.95 5.44 14.9Q5.6 14.85 5.8 14.8L5.8 9.2L5.1 9.2Z" fill={color} />
    </svg>
  );
}
